const PRELOADED_STATE="__PRELOADED_STATE__",PRELOADED_ISLANDS_STATE="__PRELOADED_ISLANDS_STATE__";export{PRELOADED_ISLANDS_STATE as P,PRELOADED_STATE as a};
